import React from 'react';
import { lyricsToggleIcon } from '@chordbaker/design';

interface LyricsToggleIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const LyricsToggleIcon: React.FC<LyricsToggleIconProps> = ({
  size = lyricsToggleIcon.defaultSize,
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={lyricsToggleIcon.viewBox}
    fill={color}
    width={size}
    height={size}
    {...props}
  >
    <path d={(lyricsToggleIcon.elements[0] as { d: string }).d} />
  </svg>
);

export default LyricsToggleIcon;
